import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Hub } from '@shared/models';
import { LoadState } from '../../loader-directive/loader.module';
import { AnalyticsService, StatCard } from '@shared/services/analytics.service';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { DurationConverter } from '../../misc/duration-converter.pipe';
import { courseLabel } from '@shared/utils/wording.utils';

@Component({
  selector: 'hub-usage',
  templateUrl: './hub-usage.component.html',
  styleUrls: ['./hub-usage.component.scss']
})
export class HubUsageComponent implements OnInit, OnChanges {
  @Input() hub: Hub;
  @Input() date_from: Date;
  @Input() date_to: Date;
  public statCardsLoadStatus = LoadState.pending;
  public statsCards: StatCard[];
  public hubDataStats: any;
  public popularCourses: { id: string, sessionCount: number }[] = [];
  public selectedFilter: string = 'visitors';

  constructor(
    private _courseAPIService: CoursesAPIService,
    private _analyticsService: AnalyticsService,

  ) { }

  async ngOnInit(): Promise<void> {
    this.initStatCards()
    this.updatePopularExperiences();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.date_from && !changes.date_from.isFirstChange() && changes.date_from.currentValue !== changes.date_from.previousValue)
      || (changes.date_to && !changes.date_to.isFirstChange() && changes.date_to.currentValue !== changes.date_to.previousValue)) {
      this.updateStatCards();
      this.updatePopularExperiences();
    }
  }
  async initStatCards(): Promise<void> {
    this.statCardsLoadStatus = LoadState.loading;
    let hubDataStats;
    try {
      hubDataStats = await this._courseAPIService.getHubStats(this.hub.id).toPromise();
    }
    catch (e) {
      this.statCardsLoadStatus = LoadState.error;
    }
    this.hubDataStats = hubDataStats;
    this.updateStatCards();
  }
  async updateStatCards(): Promise<void> {
    this.statCardsLoadStatus = LoadState.loading;
    let hubUsageStats;
    let hubAIUsageStats;

    try {
      hubUsageStats = await this._analyticsService.getHubStats(this.hub.id, { dateFrom: this.date_from, dateTo: this.date_to }).toPromise();
      hubAIUsageStats = await this._analyticsService.getHubAIStats(this.hub.id, { dateFrom: this.date_from, dateTo: this.date_to }).toPromise();
    }
    catch (e) {
      this.statCardsLoadStatus = LoadState.error;
    }
    const xpStatCard = {
      icon: 'fa-circle-plus',
      label: `<span class="figure">${hubUsageStats?.activeExperiences || 0} </span>&nbsp;<span class="label"> active XP</span>`,
      sublabel: `${this.hubDataStats.courseCount || 0} ${courseLabel(this.hub.mode, this.hubDataStats.courseCount !== 1)} in total`
    }
    const creatorsStatCard = {
      icon: 'fa-user-gear',
      label: `<span class="figure"> ${(this.hubDataStats.courseCreatorCount || 0)}</span>&nbsp;<span class="label">${(!isNaN(this.hubDataStats.courseCreatorCount) && this.hubDataStats.courseCreatorCount > 1 ? 'Creators' : 'Creator')}</span>`,
      sublabel: `${this.hubDataStats.usersTotal || 0} registered users in total`
    }
    const visitorStatCard = {
      icon: 'fa-users',
      label: `<span class="figure">${hubUsageStats?.userCount || 0} </span>&nbsp;<span class="label">${(!isNaN(hubUsageStats?.userCount) && hubUsageStats?.userCount) > 1 ? ' Visitors' : ' Visitor'}</span>`,
      sublabel: 'including ' + (hubUsageStats?.anonymousUsersCount || 0) + ' guests'
    }
    const sessionStatCard = {
      icon: 'fa-eye',
      label: `<span class="figure"> ${Math.floor((hubUsageStats?.sessionsPerVisitor || 0))}</span>&nbsp;<span class="label"> sessions/visitor</span>`,
      sublabel: `${hubUsageStats?.sessionCount} in total`
    }

    const aiStatCard = {
      icon: 'fa-message',
      label: `<span class="figure"> ${Math.ceil((hubAIUsageStats?.totalAIVoiceMinutes || 0))}</span>&nbsp;<span class="label"> AI Voice Min</span>`,
      sublabel: `${Math.ceil((hubAIUsageStats?.avgAIVoiceMinutes || 0))} min/session`
    }
    // const durationStatCard = {
    //   icon: 'fa-clock',
    //   label: `<span class="figure"> ${DurationConverter.prototype.transform(hubUsageStats.durationPerVisitor, "hh:mm")}</span>&nbsp;<span class="label">/visitor</span>`,
    //   sublabel: `${DurationConverter.prototype.transform(hubUsageStats.totalDuration, "hh:mm")} spent in total`
    // }


    this.statCardsLoadStatus = LoadState.completed;
    this.statsCards = [xpStatCard, creatorsStatCard, visitorStatCard, sessionStatCard, aiStatCard]
  }

  async updatePopularExperiences() {
    this.popularCourses = [];
    let popularXP;
    try {
      popularXP = await this._analyticsService.getHubPopularExperiences(this.hub.id, { dateFrom: this.date_from, dateTo: this.date_to, limit: 10, criteria: this.selectedFilter }).toPromise();
    }
    catch (e) {

    }
    for (const course of popularXP) {
      this.popularCourses.push({
        id: course.id,
        sessionCount: course.sessionCount
      })
    }

  }

}
